import BoletimSection from "../BoletimSection/BoletimSection";
import CardGrid from "../CardGrid/CardGrid";

function DesafioPratico26({ pract_challenge }) {
	const practicalChallenge = [
		{
			label: "Desafio",
			value: pract_challenge.desafio ? pract_challenge.desafio : "-",
		},
		{
			label: "Empresa colaboradora",
			value: pract_challenge.empresa ? pract_challenge.empresa : "-",
		},
		{
			label: "Case resolvido",
			value: pract_challenge.case ? pract_challenge.case : "-",
		},
	];
	return (
		<BoletimSection
			title={"Desafio Prático"}
			icon={"medal"}
		>
			<CardGrid data={practicalChallenge} />
		</BoletimSection>
	);
}

export default DesafioPratico26;
